import ActivityPedaInstance, { STATES } from "./ActivityPedaInstance"
import { arrayShuffle } from "../utils"
import ActivityResult from "./ActivityResult"
import { TYPES } from "./ActivitiesConverter"
import { makeObservable, observable } from "mobx"


class Proposition {
  ID
  Type
  Text
  media

  initialIndex
  userIndex

  constructor(json, initialIndex) {
    Object.assign(this, json)

    this.initialIndex = initialIndex
  }
}


export class Reordonner extends ActivityPedaInstance {

  ID
  Text
  media

  /** @type {Array<Proposition>} */
  Propositions = []


  label_top
  label_bottom


  // ceci est appelé avec le json de la première ligne, puis ensuite on y ajoute à la main les propositions avec les lignes suivantes du .data
  constructor(json) {
    super()
    Object.assign(this, json)

    this.Type = TYPES.REORDONNER
  }
  observe() {
    super.observe()
    makeObservable(this, {
      Propositions: observable,
      label_bottom: observable,
      label_top: observable
    })
  }

  getAnswer() {
    /// ICI on enregistre le userIndex dans la proposition
    this.Propositions.forEach((p, index) => {
      p.userIndex = index
    })

    return this.getIds()
  }

  localCorrect() {
    this.getAnswer()

    let nb_correct = this.Propositions.filter(p => p.userIndex === p.initialIndex).length

    let result = new ActivityResult()
    result.normalized_score = nb_correct / this.Propositions.length
    result.is_correct = result.normalized_score === 1

    this.setResult(result)
  }

  addProposition(json) {
    this.Propositions = [...this.Propositions, new Proposition(json, this.Propositions.length)]
  }

  getProposition(id) {
    return this.Propositions.find(p => p.ID === id)
  }


  shufflePropositions() {
    this.Propositions = arrayShuffle(this.Propositions)
  }

  getIds() {
    return this.Propositions.map(p => p.ID)
  }

  // ceci est appelé en y passant un json déja complet du Reordonner, tel qu'on peut le trouver dans le fichier .activities
  fromJson(json) {
    Object.assign(this, json)
    this.Propositions = this.Propositions.map(c => new Proposition(c, c.initialIndex))
    this.observe()
    return this
  }

  reset() {
    this.Propositions.forEach(p => p.userIndex = null)
    this.setResult(null)
  }

  getState() {
    let state = super.getState()
    state.Propositions = this.Propositions.map(p => { return { id : p.ID, userIndex : p.userIndex } })

    return state
  }
  setState(state) {
    super.setState(state)
    if(state.Propositions) {
      state.Propositions.forEach(p => {
        let prop = this.getProposition(p.ID)
        if (prop) {
          prop.userIndex = p.userIndex
        }
      })

    }
  }

}

export class ReordonnerFile {

    /** @type {Array<Reordonner>} */
    all = []

    constructor(json, file) {



      let current = null

      json.forEach(row => {
        try {
          if(row.Type === TYPES.REORDONNER || row.Type === "title" || row.Type === "reorder" || row.Type === "reordonner") {
            current = this.makeReordonner(row)
            this.all.push(current)
          }

          if(row.Type === "proposition") {
            current.addProposition(row)
          }

          if(row.Type === "debrief") {
            current.addDebrief(row, null)
          }

          if(row.Type === "debrief_correct") {
            current.addDebrief(row, true)
          }
          if(row.Type === "debrief_incorrect") {
            current.addDebrief(row, false)
          }

          if(row.Type === "label_top")  current.label_top = row
          if(row.Type === "label_bottom")  current.label_bottom = row
        }
        catch(err) {
          console.log("err", err)
          throw "ERREUR CREATION REORDONNER : " + row.ID + " dans " + file
        }
      })
    }

    makeReordonner(row) {
      return new Reordonner(row)
    }

    observeAll() {
      this.all.forEach(r => r.observe())
    }
    shuffleAll() {
      this.all.forEach(r => r.shufflePropositions())
    }
    get(id) {
      return this.all.find(r => r.ID === id)
    }

    /** @param {Reordonner} reordonner */
    static toDataRows(reordonner) {
      let rows = []

      // ligne de question
      rows.push({
        ID: reordonner.ID,
        Type: TYPES.REORDONNER,
        Text: reordonner.Text,
        media: reordonner.media
      })


      if(reordonner.Propositions) {
        reordonner.Propositions.forEach(p => {
          rows.push({
            ID: p.ID,
            Type: "proposition",
            Text: p.Text,
            media: p.media
          })
        })
      }

      if(reordonner.label_top) {
        rows.push(reordonner.label_top)
      }
      if(reordonner.label_bottom) {
        rows.push(reordonner.label_bottom)
      }

      if(reordonner.debriefs) {
        // lignes de debriefs
        reordonner.debriefs.forEach(d => {
          rows.push({
            ID: d.ID,
            Type: "debrief",
            Text: d.Text,
            media: d.media,
            isCorrect: d.isCorrect
          })
        })
      }

    return rows
    }
}